import { Controller } from 'stimulus';

// Keeps the hidden value field of a multiple_choice custom attribute in sync
// with the checked options, serializing the selection as a JSON array (empty
// string when nothing is selected, so optional fields stay blank).
export default class extends Controller {
  static targets = ['value', 'option'];

  sync() {
    const selected = this.optionTargets.filter((option) => option.checked).map((option) => option.value);
    this.valueTarget.value = selected.length ? JSON.stringify(selected) : '';
  }
}
